import { browser } from '@src/slide/infrastructure/module/independent/agent/common';

/**
 * 幻灯片切换类型
 */
export enum TransitionType {
    /**
     * 无效果
     */
    EMPTY = 'empty',
    /**
     * 淡入淡出
     */
    FADE = 'fade',
    /**
     * 推入
     */
    PUSH = 'push',
    /**
     * 切入
     */
    CUT = 'cut',
    /**
     * 揭开
     */
    PULL = 'pull',
    /**
     * 覆盖
     */
    COVER = 'cover',
    /**
     * 缩放
     */
    WARP = 'warp',
    /**
     * 缩放和旋转
     */
    NEWSFLASH = 'newsflash',
    /**
     * 平移
     */
    PAN = 'pan',
    /**
     * 飞过
     */
    FLY_THROUGH = 'flythrough',
    /**
     * 切换
     */
    SWITCH = 'switchKeyword',
    /**
     * 翻转
     */
    FLIP = 'flip',
    /**
     * 库
     */
    GALLERY = 'gallery',
    /**
     * 门
     */
    DOORS = 'doors',
    /**
     * 摩天轮
     */
    FERRIS = 'ferris',
    /**
     * 传送带
     */
    CONVEYOR = 'conveyor',
    /**
     * 窗口
     */
    WINDOW = 'window',
    /**
     * 框、旋转、立方体、轨道
     */
    PRISM = 'prism',
    /**
     * 擦除: 自右侧、自顶部、自左侧、自底部
     */
    WIPE = 'wipe',
    /**
     * 擦除: 从右上部、从右下部、从左上部、从左下部
     */
    STRIPS = 'strips',
    /**
     * 分割
     */
    SPLIT = 'split',
    /**
     * 显示
     */
    REVEAL = 'reveal',
    /**
     * 随机线条
     */
    RANDOM_BAR = 'randomBar',
    /**
     * 形状: 圆形
     */
    CIRCLE = 'circle',
    /**
     * 形状: 菱形
     */
    DIAMOND = 'diamond',
    /**
     * 形状: 加号
     */
    PLUS = 'plus',
    /**
     * 形状: 缩小、放大
     */
    ZOOM = 'zoom',
    /**
     * 时钟: 顺时针
     */
    WHEEL = 'wheel',
    /**
     * 时钟: 逆时针
     */
    WHEEL_REVERSE = 'wheelReverse',
    /**
     * 时钟: 楔入
     */
    WEDGE = 'wedge',
    /**
     * 闪光
     */
    FLASH = 'flash',
    /**
     * 梳理
     */
    COMB = 'comb',
    /**
     * 溶解
     */
    DISSOLVE = 'dissolve',
    /**
     * 棋盘
     */
    CHECKER = 'checker',
    /**
     * 蜂巢
     */
    HONEYCOMB = 'honeycomb',
    /**
     * 百叶窗
     */
    BLINDS = 'blinds',
    /**
     * 闪耀
     */
    GLITTER = 'glitter',
    /**
     * 涡流
     */
    VORTEX = 'vortex',
    /**
     * 碎片
     */
    SHRED = 'shred',
    /**
     * 跌落等11中华丽动画
     */
    PRESET = 'prstTrans',
    /**
     * 涟漪
     */
    RIPPLE = 'ripple',
    /**
     * 平滑
     */
    MORPH = 'morph',
    /**
     * 随机
     */
    RANDOM = 'random',
}

export enum TransitionSpeed {
    SLOW = 'slow',
    MEDIUM = 'med',
    FAST = 'fast',
    DEFAULT = 'slow',
}

export const SpeedDurationMap = {
    slow: 1000,
    med: 750,
    fast: 500,
};

export const SupportedType = [
    TransitionType.FADE,
    TransitionType.MORPH,
    TransitionType.PUSH,
    TransitionType.SWITCH,
    TransitionType.CUT,
    TransitionType.PULL,
    TransitionType.COVER,
    TransitionType.WARP,
    TransitionType.NEWSFLASH,
    TransitionType.FLIP,
    TransitionType.GALLERY,
    TransitionType.PRISM,
    TransitionType.FLASH,
];

export enum MorphType {
    BY_OBJECT = 'byObject',
    BY_WORD = 'byWord',
    BY_CHAR = 'byChar',
}

// TODO 当前代码临时用此逻辑判断，后续移动端补全后可以移除此变量
export const APPLY_TRANSITION = !browser.isMobile;

export enum TransitionTarget {
    ENTER = 'enter-target',
    EXIT = 'exit-target',
}

export enum AnimationLabel {
    NEXT = 'animation-next',
    FINAL = 'animation-final',
}

export enum ImplementationType {
    FLAT = 'flat',
    PRESERVE_3D = 'preserve-3d',
    CUSTOM = 'custom',
}

export enum PrismSubType {
    /**
     * 框
     */
    BOX = 'box',
    /**
     * 立方体
     */
    CUBE = 'cube',
    /**
     * 轨道
     */
    CONTENT_BOX = 'content-box',
    /**
     * 旋转
     */
    CONTENT_CUBE = 'content-cube',
}
